// extracted by mini-css-extract-plugin
module.exports = {"clients":"mvp-comment_clients__m_8Fd"};